export enum MeasurementTypeEnums {
    HeightAdult = 1,
    WeightAdult = 2,
    HeightNewborn = 3,
    WeightNewborn = 4,
}
